'use client';

/**
 * Самый внешний рубеж App Router: срабатывает, когда падает сам корневой layout
 * (RootLayout) — то есть когда error.tsx уже не может отрендериться, потому что
 * над ним нет живого <html>/<body>. Поэтому global-error ОБЯЗАН отрисовать
 * собственные <html> и <body> и не может опираться ни на провайдеры, ни на antd,
 * ни на глобальные стили — только autonomous inline-разметка.
 */
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="ru">
      <body style={{ margin: 0 }}>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f5f5f5',
            padding: 24,
            textAlign: 'center',
            fontFamily:
              "system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif",
          }}
        >
          <p style={{ marginBottom: 4, color: '#333', fontSize: 16, fontWeight: 500 }}>
            Приложение не удалось загрузить
          </p>
          <p style={{ marginBottom: 16, color: '#666', fontSize: 13, maxWidth: 380 }}>
            Произошла критическая ошибка. Мы уже знаем о ней. Пожалуйста, обновите
            страницу.
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              type="button"
              onClick={() => reset()}
              style={{
                padding: '8px 16px',
                background: '#2f6fed',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: 14,
              }}
            >
              Повторить
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                padding: '8px 16px',
                background: '#fff',
                color: '#333',
                border: '1px solid #d9d9d9',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: 14,
              }}
            >
              Обновить страницу
            </button>
          </div>
          {error.digest && (
            <p style={{ marginTop: 16, color: '#999', fontSize: 12 }}>
              Код ошибки: {error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  );
}
